import { Controller } from "react-hook-form";
import clsx from "clsx";
import PhoneInputLib from "react-phone-number-input";
import "react-phone-number-input/style.css";

interface IPhoneInputProps {
  name: string;
  control: any;
  errors: any;
  label?: string | React.ReactNode;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  disabled?: boolean;
  mainContainerClassName?: string;
  defaultCountry?: string;
}

const PhoneInput = ({
  name,
  control,
  errors,
  label,
  placeholder = "Phone number...",
  className,
  labelClassName,
  disabled,
  mainContainerClassName,
  defaultCountry = "US",
}: IPhoneInputProps) => {
  return (
    <div className={`${mainContainerClassName ?? ""}`}>
      {label && (
        <label
          htmlFor={name}
          className={`block ${
            labelClassName
              ? labelClassName
              : "text-sm font-medium text-gray3 text-start pb-[11px]"
          }`}
        >
          {label}
        </label>
      )}
      <Controller
        name={name ?? ""}
        control={control}
        render={({ field }) => (
          <PhoneInputLib
            international
            countryCallingCodeEditable={false}
            defaultCountry={defaultCountry as any}
            placeholder={placeholder}
            value={field.value || ""}
            onChange={(value) => field.onChange(value || "")}
            onBlur={field.onBlur}
            disabled={disabled}
            className={clsx(
              "phone-input-international",
              {
                "phone-input-error": errors && errors[name],
                "phone-input-disabled": disabled,
              },
              className
            )}
          />
        )}
      />
      {errors && errors[name] && (
        <p className="text-white ml-2 mr-1 text-sm text-start mt-1 px-[14px] py-[4px] bg-red2 rounded-tr-[20px] rounded-br-[20px] rounded-bl-[20px]">
          {errors[name]?.message?.toString()}
        </p>
      )}
    </div>
  );
};

export default PhoneInput;
